import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';
import { MediaObjectFit } from '@epicuro-next/ataraxia/models';

@Component({
  selector: 'atx-picture-in-picture',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './picture-in-picture.component.html',
  styleUrls: ['./picture-in-picture.component.scss'],
  standalone: false,
})
export class PictureInPictureComponent {
  @HostBinding('class')
  @Input()
  public objectFit: MediaObjectFit = MediaObjectFit.CONTAIN;

  @HostBinding('class.pip-active')
  @Input()
  public activate = false;

  @Output()
  public exitPip: EventEmitter<void> = new EventEmitter();

  @HostBinding('class.pip-double-size')
  public doubleSize = false;

  public toggleSize() {
    this.doubleSize = !this.doubleSize;
  }

  public close() {
    this.exitPip.emit();
  }
}
